import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/routeDivisionModal';

const initialState = fromJS({
  isOpen: false,
  isForm: true,
  loading: false,
  splitingRoutes: false,
  routeData: {}
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.openModal: {
      return state.merge({
        isOpen: true,
        isForm: true
      });
    }
    case actions.closeModal: {
      return state.merge({
        isOpen: false
      });
    }
    case actions.openForm:
      return state.mergeIn(['isForm'], true);
    case actions.closeForm:
      return state.mergeIn(['isForm'], false);
    case actions.backToForm:
      return state.mergeIn(['isForm'], true);
    case actions.splitRoute:
      return state.mergeIn(['splitingRoutes'], true);
    case actions.splitRouteSuccess: {
      return state.merge({
        splitingRoutes: false
      });
    }
    case actions.toggleLoading: {
      const payload = action.payload;

      return state.set('loading', payload);
    }
    case actions.routeValidateSuccess: {
      const { data } = action.payload;
      return state.merge({
        isForm: false,
        loading: false,
        routeData: data
      });
    }
    default:
      return state;
  }
}
